import { useState } from 'react';

import { useTranslationsContext } from '@state/checkout-contexts';
import { HeaderEmptyElement } from '@ui/checkout-components';
import { UiAccountSelectionView } from '@ui/view-account-selection';

import { AccountSelectionDrawer } from '../../components/AccountSelectionDrawer/AccountSelectionDrawer';
import { AccountsList } from '../../components/AccountsList/AccountsList';
import { BankCard } from '../../components/BankCard/BankCard';
import { CloseButton } from '../../components/HeaderWithCloseButton/HeaderWithCloseButton';
import { useCancelModal } from '../../hooks/useCancelModal/useCancelModal';
import { TRANSLATION_KEYS } from '../../utils/TranslationKeys';

import {
  ACCOUNT_SELECTION_VIEW_CANCELLATION_REASONS,
  ACCOUNT_SELECTION_VIEW_NAME,
} from './AccountSelectionView.constants';

export function AccountSelectionView() {
  const { t } = useTranslationsContext();

  const [selectedAccountId, setSelectedAccountId] = useState<string | null>(
    null
  );

  const { modal: CancelModal, openModal: triggerCancelModal } = useCancelModal({
    cancellationReasons: ACCOUNT_SELECTION_VIEW_CANCELLATION_REASONS,
    screenName: ACCOUNT_SELECTION_VIEW_NAME,
  });

  return (
    <UiAccountSelectionView.Wrapper
      headerComponentStart={<HeaderEmptyElement />}
      headerComponentEnd={<CloseButton onClick={triggerCancelModal} />}
      headerLabel={t(TRANSLATION_KEYS.SELECT_ACCOUNT)}
      persistentDrawer={
        selectedAccountId ? (
          <AccountSelectionDrawer selectedAccountId={selectedAccountId} />
        ) : null
      }
    >
      <BankCard />
      <AccountsList
        selectedAccountId={selectedAccountId}
        setSelectedAccountId={setSelectedAccountId}
      />
      {CancelModal}
    </UiAccountSelectionView.Wrapper>
  );
}
